enum CredentialTypeEnum {
  TYPE0 = 0x00,
  TYPE1 = 0x01,
  TYPE2 = 0x02, // Full Compounding
  FULL_COMPOUNDING = 0x02, // Full Compounding
}
export { CredentialTypeEnum as CredentialType, CredentialTypeEnum };
